import React from 'react';
import PropTypes from 'prop-types';
import AlertPanel from 'components/AlertPanel';
import { withStyles } from "tss-react/mui";
import styles from './styles';

const DenyReasonPanel = (props) => {
    const { denyReason, classes } = props;
    const showPanel = Boolean(denyReason) && Boolean(denyReason.reasonDescription);
    return (
        <React.Fragment>
            {showPanel &&
                <AlertPanel
                    message={denyReason.reasonDescription}
                    variant="error"
                    className={classes.alertPanel}
                />
            }
        </React.Fragment>
    );
};

DenyReasonPanel.propTypes = {
    denyReason: PropTypes.shape({
        reasonDescription: PropTypes.string
    })
};

export default withStyles(DenyReasonPanel,styles);